import LearningIcon from "@mui/icons-material/Book";
import CartIcon from "@mui/icons-material/ShoppingCart";
import WishlistIcon from "@mui/icons-material/Favorite";
import DashboardIcon from "@mui/icons-material/Dashboard";
import MessageIcon from "@mui/icons-material/Message";
import NotificationIcon from "@mui/icons-material/Notifications";
import PurchasesHistoryIcon from "@mui/icons-material/History";
import ProfileIcon from "@mui/icons-material/Person";
import SettingIcon from "@mui/icons-material/Settings";
import LogOutIcon from "@mui/icons-material/Logout";

export const menuData = [
  {
    section: "Main",
    items: [
      { label: "My learning", route: "/learning", icon: LearningIcon },
      { label: "My cart", route: "/cart", icon: CartIcon },
      { label: "Wishlist", route: "/wishlist", icon: WishlistIcon },
      { label: "Dashboard", route: "/dashboard", icon: DashboardIcon },
    ],
  },
  {
    section: "Notifications",
    items: [
      { label: "Message", route: "/message", icon: MessageIcon },
      { label: "Notification", route: "/notification", icon: NotificationIcon },
      {
        label: "Purchases History",
        route: "/purchases-history",
        icon: PurchasesHistoryIcon,
      },
    ],
  },
  {
    section: "Account",
    items: [
      { label: "My Profile", route: "/profile", icon: ProfileIcon },
      { label: "Setting", route: "/setting", icon: SettingIcon },
      { label: "Log Out", route: "/", icon: LogOutIcon },
    ],
  },
];

const roles = ["STUDENT", "TEACHER", "PARENT", "INSTRUCTOR", "ADMIN"];

const difficultyLevel = ["Easy", "Medium", "Hard"];
const noOfQos = ["1", " 2", " 3", " 4", " 5"];

const time = [
  "Daily 1-2 hrs",
  "0-2 hrs / week",
  "3-5 hrs / week",
  "5+ hrs / week",
  "I haven't decided yet",
];

const courseCategory = [
  { value: 1, label: "Programming" },
  { value: 2, label: "Design" },
];
const languages = [
  { value: "English", label: "English" },
  { value: "Spanish", label: "Spanish" },
  { value: "French", label: "French" },
];

const categories = [
  { value: "IT & Software", label: "IT & Software" },
  { value: "Finance", label: "Finance" },
  { value: "Design", label: "Design" },
  { value: "Development", label: "Development" },
  { value: "Business", label: "Business" },
  { value: "Marketing", label: "Marketing" },
  { value: "Personal Development", label: "Personal Development" },
  { value: "Teaching & Academics", label: "Teaching & Academics" },
];

const skillLevels = [
  { value: "beginner", label: "Beginner" },
  { value: "intermediate", label: "Intermediate" },
  { value: "advanced", label: "Advanced" },
];

const amounts = [
  { value: "1000", label: "1000" },
  { value: "2000", label: "2000" },
  { value: "3000", label: "3000" },
];

const currencies = [
  { value: "INR", label: "INR" },
  { value: "USD", label: "USD" },
  { value: "AUD", label: "AUD" },
];

const courseRatings = [
  { value: "All Ratings", label: "All Ratings" },
  { value: "5 Stars", label: "Five Stars" },
  { value: "4 Stars", label: "Four Stars" },
  { value: "3 Stars", label: "Three Stars" },
  { value: "2 Stars", label: "Two Stars" },
  { value: "1 Star", label: "One Star" },
];

const QnsSortBy = ["Sort by most recent", "Sort by recommended"];

const QnsTypeSortBy = ["MCQ", "Yes/No", "Short_Answer", "Fill_in_the_blank"];

const courses = ["Python", "Java", "SQL"];

const QnsFilterBy = ["Current Lecture", "All Lectures"];

const addressType: any[] = ["PRESENT", "PERMANENT"];
const cameraType = [
  "Webcam",
  "Smartphone Camera",
  "Action Camera",
  "Mirrorless",
  "DSLR",
  "I don't know",
];

const microphoneType = [
  "In-build Microphone",
  "Dynamic Microphone",
  "USB Microphone",
  "Shotgun Microphone",
  "I don't know",
];

const operatingSystem = [
  "Windows",
  "macOS",
  "Linux",
  "Android",
  "iOS",
  "I don't know",
];

const countryList: any[] = [
  "Global",
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas (the)",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia (Plurinational State of)",
  "Bonaire, Sint Eustatius and Saba",
  "Bosnia and Herzegovina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory (the)",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cabo Verde",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cayman Islands (the)",
  "Central African Republic (the)",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands (the)",
  "Colombia",
  "Comoros (the)",
  "Congo (the Democratic Republic of the)",
  "Congo (the)",
  "Cook Islands (the)",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Curaçao",
  "Cyprus",
  "Czechia",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic (the)",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Eswatini",
  "Ethiopia",
  "Falkland Islands (the) [Malvinas]",
  "Faroe Islands (the)",
  "Fiji",
  "Finland",
  "France",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories (the)",
  "Gabon",
  "Gambia (the)",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guernsey",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard Island and McDonald Islands",
  "Holy See (the)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Isle of Man",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jersey",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea (the Democratic People's Republic of)",
  "Korea (the Republic of)",
  "Kuwait",
  "Kyrgyzstan",
  "Lao People's Democratic Republic (the)",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macao",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands (the)",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia (Federated States of)",
  "Moldova (the Republic of)",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands (the)",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger (the)",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands (the)",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine, State of",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines (the)",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Republic of North Macedonia",
  "Romania",
  "Russian Federation (the)",
  "Rwanda",
  "Réunion",
  "Saint Barthélemy",
  "Saint Helena, Ascension and Tristan da Cunha",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Martin (French part)",
  "Saint Pierre and Miquelon",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Sint Maarten (Dutch part)",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "South Sudan",
  "Spain",
  "Sri Lanka",
  "Sudan (the)",
  "Suriname",
  "Svalbard and Jan Mayen",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Timor-Leste",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands (the)",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates (the)",
  "United Kingdom of Great Britain and Northern Ireland (the)",
  "United States Minor Outlying Islands (the)",
  "United States of America (the)",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela (Bolivarian Republic of)",
  "Viet Nam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna",
  "Western Sahara",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Åland Islands",
];

export {
  roles,
  difficultyLevel,
  noOfQos,
  time,
  courseCategory,
  languages,
  categories,
  skillLevels,
  amounts,
  currencies,
  courseRatings,
  QnsFilterBy,
  QnsSortBy,
  QnsTypeSortBy,
  countryList,
  addressType,
  operatingSystem,
  microphoneType,
  cameraType,
  courses,
};
